import tenants from './tenants.json';
import tenantPermissions from './tenant-permissions.json';

export default {
  tenants,
  tenantPermissions,
};
